var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 133,
    viewBox: "0 0 332 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 113.73L55 106.752L111 126H166L221 132.568H277L332 110.241V0H277H221H166H111H55H0V113.73Z",
    fill: "#188865"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.845L55 101L111 94.1932L166 113.032L221 108.845L277 105.357L332 113.73V0H277H221H166H111H55H0V108.845Z",
    fill: "#199873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 100.473L55 93.4955L111 100.473L166 86.5182L221 68.3773L277 83.7273L332 101.17V0H277H221H166H111H55H0V100.473Z",
    fill: "#19A881"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.0045L55 53.725L111 50.2364L166 63.4932L221 69.7727L277 69.075L332 66.2841V0H277H221H166H111H55H0V60.0045Z",
    fill: "#18B88F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.4909L55 53.725L111 35.5841L166 36.2818L221 36.9795L277 43.9568L332 56.5159V0H277H221H166H111H55H0V33.4909Z",
    fill: "#15C89E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.35L55 26.5136L111 30.0023L166 22.3273L221 25.1182L277 26.5136L332 24.4205V0H277H221H166H111H55H0V15.35Z",
    fill: "#0FD9AE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.ed0206ba29f9dd53d55d24729940e237.svg";
export { ForwardRef as ReactComponent };